import { Pipe, PipeTransform } from '@angular/core';
import { AnnotationTool } from '../../gallery-shared/types/annotation-tool';

@Pipe({
  name: 'annotationToolName',
  standalone: true,
})
export class AnnotationToolNamePipe implements PipeTransform {
  transform(tool: AnnotationTool): string {
    if (tool === 'oval') return 'Circle';
    if (tool === 'rect') return 'Rectangle';
    if (tool === 'arrow') return 'Arrow';
    if (tool === 'line') return 'Line';
    if (tool === 'polygon') return 'Brush';
  }
}
